/**
 * Telemetry Module
 *
 * Handles Sentry integration.
 */

import * as Sentry from "@sentry/browser";

/**
 * Sets the Sentry user context.
 *
 * @param kwInput - The KW number input element.
 * @param userNameInput - The username input element.
 * @returns void
 */
export function setSentryUser(kwInput: HTMLInputElement, userNameInput: HTMLInputElement): void {
  Sentry.setUser({
    id: kwInput.value,
    username: userNameInput.value,
  });
}

/**
 * Sets the Sentry location context.
 *
 * @param option - The option element that was selected.
 * @returns void
 */
export function setSentryLocation(option: HTMLOptionElement | undefined): void {
  if (!option) {
    console.warn("No option provided to setSentryLocation");
    return;
  }

  Sentry.setContext("Location", {
    id: option.id,
    name: option.label,
  });
}
